export const FIELDS = {
  NAME: 'Partner_Locator_Account_Name__c',
  DESCRIPTION: 'Partner_Locator_Account_Description__c',
  LOGO: 'Partner_Locator_Logo__c',
  WEBSITE: 'Partner_Locator_Website__c',
  COUNTRY: 'BillingCountry',
  CERTIFICATION: 'Partner_Locator_Certifications__c',
  FEATURED: 'Partner_Locator_Featured__c',
  SPECIALIZATION: 'Program_Specializations__c',
  AWARD_WINNER: 'Award Winner',
  BUSINESS_LEVEL: 'Business_Partner_Level__c',
  BUSINESS_CONTRACT: 'Business_Partner_Contract__c',
  SERVICE_LEVEL: 'ServicesPartnerLevel__c',
  SERVICE_CONTRACT: 'Service_Partner_Contract__c',
  PUBLIC_SECTOR_LEVEL: 'PublicSectorPartnerLevel__c',
  TECHNOLOGY_LEVEL: 'Technology_Partner_Level__c',
  TECHNOLOGY_ALLIANCE: 'Strategic_Technology_Alliance_Partner__c',
  TECHNOLOGY_CATEGORY: 'Technology_Partner_Category__c',
}

export const LEVELS = {
  PLATINUM: 'Platinum',
  GOLD: 'Gold',
  AUTHORIZED: 'Authorized',
  PREMIER: 'Premier',
}

export const CERTIFICATION = {
  PS: 'Professional Services Certified',
}

export const ID = {
  BUSINESS: '01236000000OGv1AAG',
  TECHNOLOGY: '0121Q000000OzV3QAK',
}

export const PARTNERS = {
  PARTNERS: 'partners',
  BUSINESS: 'business_partners',
  SERVICE: 'service_partners',
  PUBLIC_SECTOR: 'public_sector_partners',
  TECHNOLOGY: 'technology_alliance_partners',
  ALLIANCE: 'Strategic_Technology_Alliance_Partner__c',
  IMG: '/steam-img/partners-image-blank.png',
}

export const TYPE = {
  PARTNERS: 'partners',
  BUSINESS: 'Business Partner',
  TECHNOLOGY: 'Tech Partner',
  SERVICE: 'Service Partner',
}

export const PATH = {
  BUSINESS: '/partners/business-partners',
  SERVICE: '/partners/service-partners',
  PUBLIC_SECTOR: '/partners/public-sector-partners',
  TECHNOLOGY: '/partners/technology-alliances',
  BECOME_A_PARTNER: '/partners/become-a-partner',
}
